import React from 'react';
import {checkViolationsExist,getViolationsMsg} from '../../../Utils/CommonFunctions';
import Inputs from '../../../Components/Inputs/Inputs';

const signupForm = props => {
    const {violations} = props;
	const fieldDetail = JSON.parse(props.formData);
	//console.log(fieldDetail.email);
	return (
		<div className="form-signup animated fadeIn">

            <div className="form-group row mb-1"> 
                {/*<label htmlFor="" className="secondary_color col-4 mt-sm-2 text-right"> Name</label>*/}
                <div className="col-12">
                    <div className="row">
                        <div className="col-6 pr-1">
                            <Inputs placeholder="" fieldName="fname" formData={JSON.stringify(fieldDetail.fname)} changed={props.changed}/>
                            { checkViolationsExist('fname',violations) === true ? 
                                <span className="error text-danger">{getViolationsMsg('fname',violations)}</span>
                                : null
                            }
                        </div>
                        <div className="col-6 pl-1">
                            <Inputs fieldName="lname" formData={JSON.stringify(fieldDetail.lname)} changed={props.changed}/>
                            { checkViolationsExist('lname',violations) === true ? 
                                <span className="error text-danger">{getViolationsMsg('lname',violations)}</span>
                                : null
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className={ checkViolationsExist('companyName',violations) === true ?  "form-group row mb-1 has-error" : "form-group row mb-1"}>
                <div className="col-12">                    
                    <Inputs fieldName="company" formData={JSON.stringify(fieldDetail.company)} changed={props.changed}/>
                    { checkViolationsExist('companyName',violations) === true ? 
                        <span className="error text-danger">{getViolationsMsg('companyName',violations)}</span>
                        : null
                    }                     
                </div>
            </div>
            <div className={ checkViolationsExist('timeZone',violations) === true ?  "form-group row mb-1 has-error" : "form-group row mb-1"}>
                <div className="col-12">
                    <div className="select-arrow">
                    <Inputs fieldName="timeZone" formData={JSON.stringify(fieldDetail.timeZone)} changed={props.select2OnChangeHandler}/>
                    { checkViolationsExist('timeZone',violations) === true ? 
                        <span className="error text-danger">{getViolationsMsg('timeZone',violations)}</span>
                        : null
                    }
                    </div>
                </div>
            </div>
            <div className={ checkViolationsExist('email',violations) === true ? "form-group row mb-1 has-error" : "form-group row mb-1"}>
                <div className="col-12">
                    <Inputs fieldName="email" formData={JSON.stringify(fieldDetail.email)} changed={props.changed}/>
                    { checkViolationsExist('email',violations) === true ? 
                        <span className="error text-danger">{getViolationsMsg('email',violations)}</span>
                        : null
                    }
                    { (fieldDetail.email.error === '') ? 
                        null
                        : 
                        <span className="error text-danger">{fieldDetail.email.error}</span>
                    }
                </div>
            </div>


            <div className="form-group position-relative row mb-1">
                <div className="col-12">
                    <div className="view-password-signup" onClick={() => props.passwordViewHandler("signup","password")} style={{top:'5px', right:'20px'}}>
                        <i className={fieldDetail.password.passwordShow ? 'far fa-eye-slash fourth_light_color' : 'far fa-eye fourth_light_color'}></i>
                    </div>
                    <Inputs fieldName="password" formData={JSON.stringify(fieldDetail.password)} changed={props.changed}/>                             
                </div>
            </div>
            <div className="form-group form-action-d-flex" style={{marginLeft:'0rem'}}>
                <div className="pass_Alert">
                    <small className={props.passwordRule.lowercase ? "text-success" : "text-danger"}><i className={props.passwordRule.lowercase ? "fas fa-check" : "fas fa-times"}></i> one lowercase character</small>
                    <small className={props.passwordRule.uppercase ? "text-success" : "text-danger"}><i className={props.passwordRule.uppercase ? "fas fa-check" : "fas fa-times"}></i> one uppercase character</small>
                    <small className={props.passwordRule.specialChar ? "text-success" : "text-danger"}><i className={props.passwordRule.specialChar ? "fas fa-check" : "fas fa-times"}></i> one special character</small>
                </div>
                <div className="pass_Alert">
                    <small className={props.passwordRule.numeric ? "text-success" : "text-danger"}><i className={props.passwordRule.numeric ? "fas fa-check" : "fas fa-times"}></i> one number</small>
                    <small className={props.passwordRule.minChar ? "text-success" : "text-danger"}><i className={props.passwordRule.minChar ? "fas fa-check" : "fas fa-times"}></i> 8 characters minimum</small>
                </div>
            </div>
            <div className="form-group mb-0" style={{paddingLeft:'0rem'}}>
                <button onClick={props.clicked} className="btn col-12 signInbtn mt-3 mt-sm-0" disabled={props.signUpButtonDisabled}>
                    Sign up 
                </button>  
            </div>

            {
                props.validationSuccess  ? 
                <div className="form-group mb-0 animated slideInUp" role="alert"><span className="badge badge-success"><i className="far fa-check-circle"></i> {props.validationSuccess}</span></div> : null
            }

            {
                props.validationError  ? 
                <div className="form-group mb-0 animated slideInUp" role="alert"><span className="badge badge-danger"><i className="fas fa-exclamation-triangle"></i> {props.validationError}</span></div> : null
            }

        </div>
	);
}

export default signupForm;